import React from 'react';
import PropTypes from 'prop-types';
import Grid from '@mui/material/Grid';
import makeStyles from '@mui/styles/makeStyles';
import Typography from '@mui/material/Typography';

const useStyles = makeStyles(theme => ({
  container: {
    padding: theme.spacing(3, 5),
  },
}));

const CompanyHeader = ({ title, action }) => {
  const classes = useStyles();

  return (
    <Grid
      container
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      className={classes.container}
    >
      <Grid item>
        <Typography variant="h5">{title}</Typography>
      </Grid>
      <Grid item>{action}</Grid>
    </Grid>
  );
};

CompanyHeader.defaultProps = {
  action: undefined,
};

CompanyHeader.propTypes = {
  title: PropTypes.string.isRequired,
  action: PropTypes.node,
};

export default CompanyHeader;
